import { ref, computed, unref } from 'vue';
function useLockMeta(values) {
  const lockedUrl = ref(null);
  const lockMeta = computed(() => {
    return unref(values) || {};
  });
  const hasDob = computed(() => {
    const {
      has_dob,
      age
    } = lockMeta.value;
    return has_dob && age;
  });
  const hasCode = computed(() => {
    const {
      has_code,
      code_length
    } = lockMeta.value;
    return has_code && code_length === 4;
  });
  const hasSensitiveContent = computed(() => {
    const {
      has_sensitive_content
    } = lockMeta.value;
    return has_sensitive_content;
  });
  const isLocked = computed(() => {
    var _lockMeta$value;
    // Make sure there is lock meta and at least one of the fields is filled
    return (_lockMeta$value = lockMeta.value) === null || _lockMeta$value === void 0 ? void 0 : _lockMeta$value.is_locked;
  });
  return {
    hasDob,
    hasCode,
    hasSensitiveContent,
    isLocked,
    lockedUrl
  };
}
export { useLockMeta };